export const FakturLogo = ({ size = 32 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 240 240"
    width={size}
    height={size}
  >
    <defs>
      <linearGradient id="fGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#111111", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#3a3a3a", stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="midBar" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style={{ stopColor: "#222222", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#555555", stopOpacity: 1 }} />
      </linearGradient>
      <filter id="shadow" x="-5%" y="-5%" width="115%" height="115%">
        <feDropShadow
          dx="0"
          dy="1.5"
          stdDeviation="2.5"
          floodColor="#000000"
          floodOpacity="0.15"
        />
      </filter>
    </defs>
    <g filter="url(#shadow)">
      <rect x="45" y="30" width="32" height="185" rx="3" fill="url(#fGrad)" />
      <path d="M45 30 L195 30 L182 62 L45 62 Z" fill="url(#fGrad)" />
      <path d="M45 112 L160 112 L150 140 L45 140 Z" fill="url(#midBar)" />
      <rect
        x="98"
        y="76"
        width="3"
        height="22"
        rx="1.5"
        fill="#777"
        opacity="0.4"
      />
      <rect
        x="110"
        y="72"
        width="3"
        height="30"
        rx="1.5"
        fill="#777"
        opacity="0.25"
      />
      <rect
        x="122"
        y="76"
        width="3"
        height="22"
        rx="1.5"
        fill="#777"
        opacity="0.15"
      />
    </g>
  </svg>
);
